import React from "react";
import { motion } from "framer-motion";

export interface QuizProgressProps {
  percent: number;
}

export const QuizProgress: React.FC<QuizProgressProps> = ({ percent }) => (
  <div className="quiz-progress">
    <motion.div
      className="quiz-progress-bar"
      initial={false}
      animate={{ width: `${percent}%` }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      style={{ willChange: "width" }}
    >
      &nbsp;
    </motion.div>
  </div>
);
